import { createFileRoute } from '@tanstack/react-router'
import ContatoEditarPage from '@/pages/contatos/contato-editar'

// Rota para editar um contato específico
// Path completo será /dashboard/$dashboardId/contatos/$id/editar
// Renderizada dentro do <Outlet /> de dashboard.$dashboardId.contatos/route.tsx
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/contatos/$id/editar',
)({
  component: function ContatoEditarRoute() {
    const { dashboardId, id } = Route.useParams()
    return <ContatoEditarPage dashboardId={dashboardId} contatoId={id} />
  },
})
